import { create } from 'zustand'

export type ToastKind = 'success' | 'error' | 'info'

export interface Toast {
    id: number
    kind: ToastKind
    message: string
}

interface ToastState {
    toasts: Toast[]
    push: (kind: ToastKind, message: string) => void
    dismiss: (id: number) => void
}

let nextId = 1

export const useToastStore = create<ToastState>()(set => ({
    toasts: [],
    push: (kind, message) => {
        const id = nextId++
        set(s => ({ toasts: [...s.toasts, { id, kind, message }] }))
        setTimeout(() => {
            set(s => ({ toasts: s.toasts.filter(t => t.id !== id) }))
        }, 4500)
    },
    dismiss: id => set(s => ({ toasts: s.toasts.filter(t => t.id !== id) })),
}))

export const toast = {
    success: (msg: string) => useToastStore.getState().push('success', msg),
    error: (msg: string) => useToastStore.getState().push('error', msg),
    info: (msg: string) => useToastStore.getState().push('info', msg),
}
